export const selectChallenges = (state) => state.challenges;
